import React, { useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import Swal from "sweetalert2";

const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const udata = JSON.parse(localStorage.getItem("udata"));

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  const history = useHistory();

  const access_token = localStorage.getItem("token");
  //   const walletUpdate =()=>{
  //  io.emit("getprofile", access_token);
  //   io.on("setProfile", (data) => {
  //     setUser(data);
  //   });
  //   }

  //   useEffect(()=>{
  //     walletUpdate()
  //   },[]);

  return (
    <>
      <div className="leftContainer mb_space">
        <div className="pt-4  Orher_page_main_section">
          <div className="wallet-container">
            {/* Deposit Card */}
            <div className="modern-card deposit-gradient">
              <div className="card-content">
                <div className="card-info">
                  <h2 className="card-title">Deposit Cash</h2>
                  <div className="balance-section">
                    <img
                      src="/coin.png"
                      alt="coin"
                      className="coin-icon"
                    />
                    <div className="balance-text">
                      <span className="balance-amount">
                        ₹{user?.Wallet_balance ?? 0}
                      </span>
                      <span className="balance-label">Deposit Chips</span>
                    </div>
                  </div>
                </div>
                <div className="card-action">
                  <button
                    className="action-btn deposit-btn"
                    onClick={(e) => {
                      if (udata?.verified !== "verified") {
                        e.preventDefault();
                        Swal.fire({
                          title: "KYC Pending",
                          text: "कृपया 👉 Deposit add करने से पहले KYC कम्पलीट करें 🙏",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonText: "Verify Now",
                          cancelButtonText: "Later",
                          confirmButtonColor: "#1e293b",
                          cancelButtonColor: "#64748b",
                        }).then((result) => {
                          if (result.dismiss === Swal.DismissReason.cancel) {
                            history.push("/profile");
                          }
                        });
                      } else {
                        history.push("/addcase");
                      }
                    }}
                  >
                    Add Cash
                  </button>
                </div>
              </div>
            </div>

            {/* Withdraw Card */}
            <div className="modern-card withdraw-gradient">
              <div className="card-content">
                <div className="card-info">
                  <h2 className="card-title">Winning Cash</h2>
                  <div className="balance-section">
                    <img
                      src="/coin.png"
                      alt="coin"
                      className="coin-icon"
                    />
                    <div className="balance-text">
                      <span className="balance-amount">
                        ₹{user?.withdrawAmount ?? 0}
                      </span>
                      <span className="balance-label">
                        Withdrawable Balance
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-action">
                  <Link to="/Withdrawopt" style={{ textDecoration: "none" }}>
                    <button className="action-btn withdraw-btn">
                      Withdraw
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
